import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ConditionSubsequentStatusPageUI from './ConditionSubsequentStatusPageUI.js'

class ConditionSubsequentStatusPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountCsStatusList: null,
      checked: false,
      fileNameSet: new Set(),
      downloadRequested: false,
      downloadErrorList: []
    }
  }

  render() {
    return (
      <ConditionSubsequentStatusPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        fileNameSet={this.state.fileNameSet}
        accountCsStatusList={this.state.accountCsStatusList}
        onRefreshClick={this.onRefreshClick}
        checked={this.state.checked}
        onShowLoans={this.onShowLoans}
        downloadRequested={this.state.downloadRequested}
        downloadErrorList={this.state.downloadErrorList}
        onDownloadClick={this.onDownloadClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCsStatus(context)
  }

  getCsStatus(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/compliance/statuses`,
      cacheKey: CacheKeys.CsStatus(),
      callback: this.getCsStatusCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context)
  }

  getCsStatusCallback = (response) => {
    let fileNameSet = new Set()
    response.accountCsStatusList.map((a) =>
      a.loanCsStatusList.map((l) =>
        l.csStatusList.map((cs) =>
          fileNameSet.add(cs.fileName)
        )
      )
    )
    // put other at the end
    // although a set, most JavaScript engines maintains the insert order
    fileNameSet.delete('Other')
    fileNameSet.add('Other')
    this.setState({
      errorList: response.errorList,
      fileNameSet: fileNameSet,
      accountCsStatusList: response.accountCsStatusList
    })
  }

  onShowLoans = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onDownloadClick = () => {
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/compliance/statuses/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }


  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.CsStatus())
    this.setState({ accountCsStatusList: null, errorList: null }, () => {
      this.getCsStatus(this.props.context)
    })
  }

}

export default withRouter(ConditionSubsequentStatusPageSF)
